<template>
  <v-snackbar
    v-model="active"
    :timeout="timeout"
    :top="true"
    :right="true"
    :color="color"
    multi-line
  >
    {{ message }}
    <v-btn
      dark
      flat
      @click.native="active = false"
    >Close</v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Snackbar',
  data: () => ({
    y: 'top',
    x: 'right',
    timeout: 5000,
  }),
  computed: {
    active: {
      get() {
        return this.$store.getters['snackbar/snackbarActive'];
      },
      set() {
        this.$store.commit('snackbar/snackbarStop');
      },
    },
    ...mapGetters({
      color: 'snackbar/snackbarColor',
      message: 'snackbar/snackbarMessage',
    }),
  },
};
</script>

<style scoped>

</style>
